export default __webpack_public_path__ + "static/media/publisher1.998ce3c8.png";